import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">

<path d="M3955 8913 c-27 -2 -54 -9 -60 -14 -7 -7 1 -8 25 -4 19 3 76 10 125
14 79 7 82 8 25 8 -36 0 -87 -2 -115 -4z"/>
<path d="M4161 8906 c2 -2 33 -6 69 -9 41 -4 56 -3 40 3 -25 8 -117 14 -109 6z"/>
<path d="M3800 8890 c-21 -7 -21 -8 -5 -9 11 0 27 4 35 9 18 11 5 11 -30 0z"/>
<path d="M6440 8890 l-125 -6 115 -1 c63 -1 138 2 165 7 46 7 47 7 10 7 -22
-1 -96 -4 -165 -7z"/>
<path d="M6800 8866 c0 -35 -1 -36 -40 -36 -29 0 -40 -4 -40 -15 0 -12 -20
-15 -120 -15 l-120 0 0 -40 0 -40 -280 0 -280 0 0 -25 c0 -22 -4 -25 -40 -25
-29 0 -40 -4 -40 -15 0 -13 -29 -15 -200 -15 -171 0 -200 -2 -200 -15 0 -12
-20 -15 -120 -15 -100 0 -120 3 -120 15 0 11 -11 15 -40 15 l-40 0 0 -40 0
-40 -40 0 c-37 0 -41 -3 -47 -31 -4 -22 -9 -27 -17 -19 -7 7 -7 16 2 31 12 19
11 20 -10 15 -13 -3 -17 -3 -10 0 6 3 12 23 12 45 0 35 -3 39 -25 39 -14 0
-25 -6 -25 -12 -1 -15 -50 42 -50 57 0 6 4 3 10 -5 11 -17 15 -13 24 20 3 14
3 19 0 12 -5 -10 -9 -10 -22 0 -12 11 -16 11 -20 0 -3 -10 -9 -9 -24 5 -13 11
-8 -1 13 -35 70 -110 115 -188 134 -232 11 -25 22 -47 26 -50 4 -3 68 -127
143 -276 l135 -272 944 -1 c593 0 970 -4 1016 -11 586 -83 1010 -476 1106
-1024 9 -53 15 -148 15 -235 0 -232 -35 -392 -130 -586 -179 -370 -508 -626
-930 -726 -114 -27 -475 -37 -1525 -42 -477 -2 -799 -7 -796 -13 2 -5 7 -18
11 -29 5 -11 49 -103 98 -205 189 -390 280 -579 332 -687 l53 -113 851 0 c850
0 1048 6 1207 35 503 94 901 307 1249 671 356 374 578 857 641 1399 16 141 16
420 0 555 -35 287 -125 591 -238 807 -223 428 -590 781 -1033 995 -128 62
-276 122 -330 133 -19 4 -39 11 -45 15 -12 10 -303 75 -400 90 -38 6 -195 14
-347 17 l-278 6 0 -37z m809 -35 c8 -5 -5 -7 -35 -4 -27 3 -51 7 -53 9 -9 8
75 3 88 -5z m14 -28 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z"/>
<path d="M4343 8883 c19 -5 21 -11 7 -33 -10 -16 -12 -17 -70 -19 -28 -1 -40
-5 -40 -16 0 -12 -16 -15 -80 -15 -64 0 -80 -3 -80 -15 0 -11 -11 -15 -40 -15
-28 0 -40 4 -40 14 0 12 -24 15 -123 18 -114 3 -123 2 -119 -14 4 -16 -4 -18
-69 -17 -41 0 -92 4 -114 8 l-40 8 28 11 c16 7 33 12 38 12 5 0 28 8 52 19 23
10 57 24 75 31 18 7 30 15 28 17 -6 6 -228 -77 -236 -88 -3 -3 -21 -14 -40
-24 -68 -35 -176 -131 -235 -210 -16 -22 -32 -42 -35 -45 -18 -17 -345 -667
-512 -1015 -42 -88 -127 -263 -189 -390 -61 -126 -137 -284 -169 -350 -32 -66
-95 -196 -140 -290 -45 -93 -128 -267 -185 -385 -57 -118 -135 -282 -175 -365
-40 -82 -92 -193 -117 -245 -25 -52 -82 -174 -128 -270 -45 -96 -97 -206 -115
-245 -33 -72 -306 -648 -340 -719 -11 -22 -18 -41 -17 -43 2 -1 221 -4 488 -5
542 -3 544 -3 682 70 127 66 217 172 299 351 22 47 55 118 73 156 18 39 51
108 73 155 43 94 234 502 289 620 78 165 348 745 508 1090 355 765 444 950
457 950 5 0 8 -4 8 -9 0 -5 45 -103 101 -218 56 -114 117 -242 136 -283 20
-41 87 -180 149 -308 63 -129 114 -235 114 -237 0 -2 37 -80 81 -172 96 -199
165 -343 225 -472 l44 -93 -548 3 -547 4 -59 -23 c-177 -67 -254 -151 -416
-457 -30 -55 -63 -118 -75 -140 -87 -161 -217 -426 -212 -432 11 -11 2077 -17
2077 -6 0 5 -52 115 -116 244 -115 231 -180 366 -196 403 -8 19 8 19 767 14
429 -3 778 -1 781 3 5 9 -4 31 -164 359 -148 304 -233 482 -357 740 -59 124
-153 317 -208 430 -55 113 -140 288 -189 390 -113 233 -491 989 -547 1094 -42
78 -111 192 -141 231 -27 35 -145 150 -168 163 -73 41 -141 71 -172 75 -19 2
-27 2 -17 0z m82 -43 c3 -6 -1 -7 -9 -4 -18 7 -21 14 -7 14 6 0 13 -4 16 -10z
m60 -20 c3 -6 -1 -7 -9 -4 -18 7 -21 14 -7 14 6 0 13 -4 16 -10z"/>
<path d="M4883 8883 c15 -2 39 -2 55 0 15 2 2 4 -28 4 -30 0 -43 -2 -27 -4z"/>
<path d="M5098 8883 c34 -2 90 -2 125 0 34 2 6 3 -63 3 -69 0 -97 -1 -62 -3z"/>
<path d="M6118 8883 c23 -2 61 -2 85 0 23 2 4 4 -43 4 -47 0 -66 -2 -42 -4z"/>
<path d="M3665 8810 c-4 -6 3 -10 14 -10 25 0 27 6 6 13 -8 4 -17 2 -20 -3z"/>
<path d="M4820 8795 c0 -5 9 -21 20 -35 11 -14 20 -20 20 -15 0 6 -9 21 -20
35 -11 14 -20 21 -20 15z"/>
<path d="M4946 8673 c-4 -9 -2 -21 4 -27 7 -7 10 -2 10 17 0 31 -5 34 -14 10z"/>
<path d="M1796 3743 c-4 -9 -51 -91 -105 -182 -54 -91 -125 -213 -158 -271
-33 -58 -103 -181 -157 -275 -53 -93 -101 -177 -106 -186 -87 -157 -110 -201
-113 -210 -1 -7 51 -10 162 -10 90 0 165 2 166 3 1 2 18 33 39 71 l37 67 284
0 c221 0 285 3 285 13 0 12 -93 174 -111 192 -5 6 -81 12 -167 15 -183 6 -177
1 -114 108 21 37 73 128 115 202 111 198 93 191 167 59 35 -63 90 -161 123
-219 124 -216 277 -493 277 -502 0 -9 -7 -9 185 -9 83 0 149 4 148 9 -1 5 -62
114 -136 243 -123 215 -162 282 -297 514 -25 44 -86 149 -134 233 l-88 152
-148 0 c-130 0 -149 -2 -154 -17z"/>
<path d="M3160 3187 c0 -316 2 -576 4 -578 2 -2 70 -3 150 -1 l146 3 0 351
c-1 193 1 352 3 355 3 2 83 -91 178 -208 284 -346 341 -414 349 -414 7 0 105
112 177 200 74 92 255 309 315 379 15 17 28 34 28 39 0 4 5 7 10 7 6 0 10
-124 10 -353 0 -195 2 -356 4 -358 2 -2 70 -3 150 -1 l146 3 0 575 0 574 -156
0 -155 0 -27 -32 c-29 -34 -134 -163 -354 -435 -77 -95 -141 -173 -143 -173
-2 0 -39 44 -82 98 -42 53 -80 99 -83 102 -3 3 -21 25 -40 50 -19 25 -37 47
-40 50 -3 3 -21 25 -40 50 -19 25 -37 47 -40 50 -3 3 -27 32 -52 65 -25 33
-54 69 -65 80 -10 11 -31 37 -47 58 l-28 37 -159 0 -159 0 0 -573z"/>
<path d="M5360 3185 l0 -575 150 0 150 0 0 438 c0 242 -3 500 -7 575 l-6 137
-144 0 -143 0 0 -575z"/>
<path d="M6172 3183 l3 -576 145 0 145 0 5 459 5 459 325 0 c315 0 326 -1 366
-22 121 -65 107 -222 -25 -282 -29 -13 -85 -17 -286 -21 l-250 -5 91 -95 c51
-52 106 -111 124 -130 18 -19 104 -108 190 -197 l158 -162 182 -1 c100 -1 183
0 185 2 4 4 -66 79 -256 275 -55 56 -96 104 -92 106 5 3 28 8 53 12 112 18
235 107 281 204 49 104 48 245 -2 344 -29 56 -96 119 -160 150 -108 53 -150
57 -692 57 l-497 0 2 -577z"/>
<path d="M8581 3731 c-12 -16 -21 -32 -21 -35 0 -3 -25 -47 -57 -98 -31 -51
-80 -133 -108 -183 -29 -49 -118 -205 -200 -345 -81 -140 -161 -280 -178 -310
-17 -30 -43 -75 -58 -100 -15 -24 -26 -46 -24 -48 2 -2 75 -4 162 -4 183 1
157 -14 246 147 72 132 111 201 247 440 62 110 120 212 127 228 17 33 26 34
41 5 22 -45 94 -173 127 -229 19 -31 35 -59 35 -62 0 -3 18 -36 40 -75 22 -38
40 -74 40 -81 0 -8 -43 -11 -149 -11 -132 0 -151 -2 -173 -19 -24 -19 -118
-171 -118 -191 0 -7 97 -10 285 -10 l284 0 37 -67 c21 -38 39 -70 40 -72 2 -2
288 -4 332 -1 2 0 -9 21 -24 48 -15 26 -38 65 -50 87 -78 144 -200 361 -309
550 -70 121 -159 275 -197 343 l-71 122 -143 0 -143 0 -20 -29z"/>
<path d="M3588 2098 c-2 -128 -2 -239 0 -245 6 -19 204 -17 270 2 176 53 232
290 97 413 -56 52 -94 62 -242 62 l-121 0 -4 -232z m282 130 c54 -37 73 -70
73 -130 1 -66 -22 -115 -69 -147 -29 -20 -52 -26 -120 -29 l-84 -5 0 167 0
166 84 0 c70 0 88 -4 116 -22z"/>
<path d="M4847 2298 c-8 -18 -55 -125 -106 -238 -50 -113 -91 -209 -91 -213 0
-5 21 -7 46 -5 46 3 47 4 68 55 l21 53 126 0 126 0 18 -55 19 -55 49 0 c36 0
48 3 44 13 -3 6 -26 59 -50 117 -25 58 -69 161 -99 230 l-55 125 -51 3 c-50 3
-52 2 -65 -30z m78 -80 c4 -13 23 -58 41 -102 19 -43 33 -81 30 -83 -2 -3 -42
-5 -88 -5 -66 -1 -83 2 -81 13 3 24 78 199 85 199 4 0 10 -10 13 -22z"/>
<path d="M5732 2293 l3 -38 80 0 80 -1 3 -207 2 -208 43 3 42 3 -1 203 0 202
60 1 c116 2 111 0 114 42 l3 37 -216 0 -216 0 3 -37z"/>
<path d="M6911 2308 c-5 -13 -33 -77 -64 -143 -89 -194 -137 -304 -137 -315 0
-6 19 -10 43 -10 43 0 43 0 66 55 l23 55 128 0 129 0 19 -52 c19 -53 20 -53
66 -56 25 -2 46 -2 46 0 0 9 -43 115 -84 208 -26 58 -64 144 -84 192 l-37 88
-53 0 c-45 0 -54 -3 -61 -22z m74 -90 c4 -13 23 -58 41 -102 19 -43 32 -81 30
-84 -9 -9 -166 -10 -172 -1 -3 5 11 43 31 85 19 42 38 87 41 100 8 30 21 31
29 2z"/>
<path d="M1130 2085 l0 -25 1000 0 1000 0 0 25 0 25 -1000 0 -1000 0 0 -25z"/>
<path d="M7580 2085 l0 -25 983 0 c541 0 986 3 989 6 3 3 4 14 1 25 -5 19 -24
19 -989 19 l-984 0 0 -25z"/>
</g>
</svg>






    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
